import './Menu.style.scss';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import document from '../../../assets/img/document.svg';
import bus from '../../../assets/img/bus_marker.svg';
import phone from '../../../assets/img/phone.svg';
import arrow from '../../../assets/img/arrow.svg';
import mapIco from '../../../assets/img/map-location.svg';
import feedback from '../../../assets/img/feedback.svg';
import { decrypt } from '../../../utilities/Encriptacion';
import {getPol} from "./Menu.service";

const Menu: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
    const [image, setImage] = useState<string | undefined>(undefined);
    const [company, setCompany] = useState<string | undefined>(undefined);
    const [documentPol, setDocumentPol] = useState<string | undefined>(undefined);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const toggleSubMenu = () => {
        setIsSubMenuOpen(!isSubMenuOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    useEffect(() => {
        const CLAVE = process.env.REACT_APP_CLAVE_ENCRYPTION;
        const data = decrypt(sessionStorage.getItem('dataClient'), CLAVE);
        const parsedData = JSON.parse(data);
        setImage(parsedData.image);
        setCompany(parsedData.initials);
        if(company) {
            getPol(setDocumentPol, company);
        }
    }, [company]);

    return (
        <nav className="navbar">
            <div className="navbar-brand">
                <img className={'img-logo'} src={image} alt="logo"/>
            </div>
            <div className={`navbar-menu ${isOpen ? 'is-open' : ''}`}>
                <Link to={`/${company}/panel`} onClick={closeMenu}>
                    <img src={mapIco} alt="Mapa" /> Mapa
                </Link>
                <Link to={`/${company}/paradas`} onClick={closeMenu}>
                    <img src={bus} alt="Paradas"/> Paradas
                </Link>
                <Link to={`/${company}/contacto`} onClick={closeMenu}>
                    <img src={phone} alt="Contacto" /> Contacto
                </Link>
                <a
                    href={documentPol}
                    target="_blank"
                    rel="noreferrer"
                    onClick={closeMenu}
                >
                    <img src={document} alt="Politica de servicios" /> Politica de servicios
                </a>
                <div className="nav-sub" onClick={toggleSubMenu}>
                    <img src={document} alt="Protocolos de seguridad" />
                    <span>Protocolos de seguridad</span>
                    <img src={arrow} alt="arrow" />
                    <div className={`sub-item ${isSubMenuOpen ? 'is-open' : ''}`}>
                        <a
                            href="https://repo.sumaenlinea.mx/documentos/protocolo-emergencias-de-seguridad.html"
                            target="_blank"
                            rel="noreferrer"
                            onClick={closeMenu}
                        >
                            Plan contingencia emergencia seguridad
                        </a>
                        <a
                            href="https://repo.sumaenlinea.mx/documentos/protocolo-robo-de-unidad.html"
                            target="_blank"
                            rel="noreferrer"
                            onClick={closeMenu}
                        >
                            Plan contingencia robo de unidad
                        </a>
                        <a
                            href="https://repo.sumaenlinea.mx/documentos/protocolo-secuestro.html"
                            target="_blank"
                            rel="noreferrer"
                            onClick={closeMenu}
                        >
                            Plan contingencia secuestro
                        </a>
                        <a
                            href="https://repo.sumaenlinea.mx/documentos/protocolo-siniestro.html"
                            target="_blank"
                            rel="noreferrer"
                            onClick={closeMenu}
                        >
                            Plan contingencia siniestro
                        </a>
                    </div>
                </div>
                <a
                    href="https://repo.sumaenlinea.mx/documentos/POLITICA_GARANTIA_SERVICIO.html"
                    target="_blank"
                    rel="noreferrer"
                    onClick={closeMenu}
                >
                    <img src={document} alt="Garantias de servicio" /> Garantias de servicio
                </a>
                <Link to={`/${company}/comentarios`} onClick={closeMenu}>
                    <img src={feedback} alt="Comentarios" /> Comentarios
                </Link>
            </div>
            <div className="hamburger-menu" onClick={toggleMenu}>
                <div className={`bar ${isOpen ? 'bar1' : ''}`}></div>
                <div className={`bar ${isOpen ? 'bar2' : ''}`}></div>
                <div className={`bar ${isOpen ? 'bar3' : ''}`}></div>
            </div>
        </nav>
    );
};

export default Menu;
